import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import "rxjs/add/operator/toPromise";

import { Staff } from "../../_models/staff.model";

@Injectable()
export class StaffService {
    constructor(private http: Http) { }

    list() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        return this.http.get("https://portal.sportgait.com/staff.php", {
            headers: headers
        })
            .toPromise()
            .then((res: Response) => {
                let data = res.json();
                let allStaff = [];

                console.log(data);

                data.data.forEach((entry) => {
                    let staff = new Staff();
                    staff.name = entry.name;
                    staff.id = entry.RecordID;
                    allStaff.push(staff);
                });

                return allStaff;
            })
            .catch(this.handleError);
    }
    get(id: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        console.log(id);

        return this.http.get("https://portal.sportgait.com/staff.php?query[id]=" + id, {
            headers: headers
        })
            .toPromise()
            .then((res: Response) => {
                let data = res.json();
                let staff = new Staff();
                staff.name = data.data[0].name;
                staff.id = data.data[0].RecordID;

                /*
                    data.types.forEach((eachType) => {
                      staff.types.push(eachType.type.name);
                    });
                
                    data.stats.forEach((eachStat) => {
                      staff.stats.push({
                        name: eachStat.stat.name,
                        value: eachStat.base_stat
                      });
                    });
                    */

                return staff;
            })
            .catch(this.handleError);
    }



    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || "";
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Promise.reject(errMsg);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/association/staff-service.ts